import React, { useState } from 'react';
import { Form, Button, Alert, Spinner } from 'react-bootstrap';
import { getV2Api } from '../../config';
import mixpanel from 'mixpanel-browser';
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min';
import { trackFormSubmit } from '../../helpers/analytics';

const MailingListSignupComponent = () => {
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Prevent multiple submissions
    if (isLoading) return;
    
    setIsLoading(true);

    // Track event with Mixpanel
    mixpanel.track('Sign-up Newsletter', {
      section: 'main',
      first_name: firstName,
      last_name: lastName,
      email_address: email
    });

    mixpanel.people.set({
      $name: `${firstName} ${lastName}`,
      $email: email,
    });
    
    // Track event with Google Analytics
    trackFormSubmit('newsletter', 'main', {
      first_name: firstName,
      last_name: lastName,
      email_address: email
    });
    
    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Invalid email address');
      setShowError(true);
      return;
    }

    try {
      const response = await fetch(`${getV2Api()}email-subscribe`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email,
          first_name: firstName,
          last_name: lastName
        })
      });

      if (response.ok) {
        // Reset form and show success message
        setShowSuccess(true);
        setEmail('');
        setFirstName('');
        setLastName('');
        
        // Hide success message after 3 seconds
        setTimeout(() => {
          setShowSuccess(false);
        }, 3000);
      } else {
        setError('Something went wrong, try again later...');
        setShowError(true);
      }
    } catch (error) {
      console.error('Subscription error:', error);
      setError('Something went wrong, try again later...');
      setShowError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
  <div className="mailing-list-signup">
    <div className="signup-content">
      <div className="signup-text">
        <h3>Join our Community</h3>
        <p>
          Subscribe now and receive <strong>7% OFF</strong> your first booking! 
          Stay updated with insider secrets and experiences.
        </p>
        
        {showSuccess && (
          <Alert variant="success" onClose={() => setShowSuccess(false)} dismissible>
            Thank you for subscribing! Check your email for your exclusive discount.
          </Alert>
        )}
        
        {showError && (
          <Alert variant="danger" onClose={() => setShowError(false)} dismissible>
            {error}
          </Alert>
        )}
        
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="formBasicFirstName">
            <Form.Control 
              type="text" 
              placeholder="First Name" 
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formBasicLastName">
            <Form.Control 
              type="text" 
              placeholder="Last Name (Optional)" 
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Control 
              type="email" 
              placeholder="Enter your email" 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <Form.Text>
              By clicking Subscribe, you agree to our <NavLink to="/privacy-policy">Privacy Policy</NavLink>.
            </Form.Text>
          </Form.Group>
          
          <div>
            <Button 
              variant="primary" 
              type="submit"
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                  Submitting...
                </>
              ) : (
                'Subscribe'
              )}
            </Button>
          </div>
        </Form>
      </div>

      <div className="signup-image">
        <img 
          src="/images/mercedes-driver-open-door.jpg" 
          alt="Mailing List Signup" 
        />
      </div>
    </div>
  </div>
);
};

export default MailingListSignupComponent;
